import { useSelect } from "@wordpress/data";
import { useState, useEffect } from "@wordpress/element";

export default function light({ attributes, docSections, articlesNumber }) {
    const { col, docs_layout, readMoreText, show_topic, topic_label, sectionButton, sectionButtonText, btnURL, orderBy, child_docs_order, sectionsNumber, isFeaturedImage } = attributes;
    const layoutType = docs_layout === "grid" ? `ezd-grid ezd-column-${col}` : `ezd-masonry-wrap ezd-masonry-col-${col}`;

    const allDocItems = useSelect((select) => {
        const parentIds = docSections?.map((section) => section.id) || [];
        return parentIds.map((parentId) => ({
            parentId,
            items: select("core").getEntityRecords("postType", "docs", {
                per_page: articlesNumber,
                order: child_docs_order,
                orderby: orderBy,
                parent: parentId,
                status: ['publish', 'private']
            }),
        }));
    }, [articlesNumber, docSections, child_docs_order, orderBy]);

    const childCounts = allDocItems.reduce((acc, { parentId, items }) => {
        acc[parentId] = items ? items.length : 0;
        return acc;
    }, {});


    // State for all featured media images
    const [images, setImages] = useState({});

    useEffect(() => {
        const fetchImages = async () => {
            if (!Array.isArray(docSections)) {
                return;
            }
    
            const imagePromises = docSections.map(async (section) => {
                if (section.featured_media) {
                    try {
                        const media = await wp.apiFetch({ path: `/wp/v2/media/${section.featured_media}` });
                        return { id: section.id, imageUrl: media.source_url };
                    } catch (error) {
                        console.error("Error fetching media:", error);
                        return { id: section.id, imageUrl: null };
                    }
                }
                return { id: section.id, imageUrl: null };
            });
    
            const results = await Promise.all(imagePromises);
            const imageMap = results.reduce((acc, { id, imageUrl }) => {
                acc[id] = imageUrl;
                return acc;
            }, {});
            setImages(imageMap);
        };
    
        const safeDocSections = docSections || [];
        fetchImages(safeDocSections);
    }, [docSections]);

    return (
        <>
        <div className={`${layoutType}`}>
            {docSections &&
                docSections.map((section) => {
                    const { id, title, featured_media } = section;

                    const docItems = allDocItems.find((item) => item.parentId === id)?.items || [];
 
                    // Get the image URL from state
                    const imageUrl = images[id];

                    return (
                        <div key={id} className="categories_guide_item box-item wow fadeInUp single-doc-layout-one light-style"> 
                            {/* Featured Image */}
                            
                          {isFeaturedImage && imageUrl && (
                            <img src={imageUrl} alt={title.rendered} />
                          )}

                            {/* Section Title */}
                            <div className="doc-top ezd-d-flex ezd-align-items-start">
                                <a className="doc_tag_title" href="#">
                                    <h4 className="title">{title.rendered}</h4>
                                    {show_topic && (
                                        <span class="ezd-badge"> {childCounts[section.id]} {topic_label}</span>
                                    )}
                                </a>
                            </div>

                            {/* Child Documents */}
                            <ul className="ezd-list-unstyled tag_list">
                                {docItems &&
                                    docItems.map((item) => (
                                        <li key={item.id}>
                                            <svg
                                                viewBox="0 0 32 32"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                            >
                                                <path d="M 4,32l 24,0 c 1.104,0, 2-0.896, 2-2L 30,2 c0-1.104-0.896-2-2-2L 4,0 C 2.896,0, 2,0.896, 2,2l0,28 C 2,31.104, 2.896,32, 4,32z M 4,2l 24,0 l0,28 L 4,30 L 4,2 zM 23,6l-8,0 C 14.448,6, 14,6.448, 14,7C 14,7.552, 14.448,8, 15,8l 8,0 C 23.552,8, 24,7.552, 24,7 C 24,6.448, 23.552,6, 23,6zM 23,12l-14,0 C 8.448,12, 8,12.448, 8,13C 8,13.552, 8.448,14, 9,14l 14,0 C 23.552,14, 24,13.552, 24,13 C 24,12.448, 23.552,12, 23,12zM 23,18l-14,0 C 8.448,18, 8,18.448, 8,19C 8,19.552, 8.448,20, 9,20l 14,0 c 0.552,0, 1-0.448, 1-1 C 24,18.448, 23.552,18, 23,18zM 23,24l-14,0 C 8.448,24, 8,24.448, 8,25C 8,25.552, 8.448,26, 9,26l 14,0 c 0.552,0, 1-0.448, 1-1 C 24,24.448, 23.552,24, 23,24z"></path>
                                            </svg>
                                            <a className="ct-content-text" href="#">
                                                {item.title.rendered}
                                            </a>
                                        </li>
                                    ))}
                            </ul>

                            {/* Read More Button */}
                            <a href="#" className="doc_border_btn">
                                {readMoreText} <i className="arrow_right"></i>
                            </a>
                        </div>
                    );
                } ) }
        </div>
        {sectionButton && (
            <div class="text-center">
                <a href={`${btnURL}`} class="action_btn all_doc_btn wow fadeinUp">
                    {sectionButtonText} <i class="arrow_right"></i>
                </a>
            </div>
        )}
    </>
    );
}